<template>
  <div :class="$style.box">
    <div :class="$style['btn-wrapper']">
      <button @click="showLotteryRule"></button>
      <!-- <button @click="showLotteryDialog('lotteryAddress')"></button> -->
      <button @click="showLotteryRecord"></button>
    </div>
    <div :class="$style['lottery-wrapper']">
      <ul :class="$style['lottery-list']">
        <li
          v-for="(item, index) in lotteryList"
          :key="item.id"
          :class="$style['lottery-item']"
          :style="{
            backgroundImage:
              selectIndex == index ? `url(${$cdnUrl}/sign_gift_act/gift_bg_02.png)` : '',
          }"
          @click.stop="startMove(index)"
        >
          <img :src="item.icon" />
          <div v-if="index == 4">剩余次数：{{ lotteryTimes }}</div>
        </li>
      </ul>
    </div>
    <div :class="$style['radio-wrapper']"></div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { Dialog } from 'vant';
import { getLotteryResultInfo } from '@/api/activity';
export default {
  props: {
    lotteryList: {
      type: Array,
      default: () => []
    },
    lotteryTimes: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectIndex: 0, // 所选奖品的index
      lotteryClickFlag: false, // 防止重复点击抽奖按钮
      prizeIndex: 0,
      arrNum: [0, 1, 2, 5, 8, 7, 6, 3], // 定义转动的顺序
      timerQuick: null, // 快速转动
      timerSlow: null, // 慢速转动
      lotteryResult: {}, // 抽奖结果信息
    };
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false
      return flag;
    },
    // 活动id
    activityId() {
      return Number(this.$route.query.activityId)
    },
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME'
    }),
    // 显示抽奖规则弹窗
    showLotteryRule() {
      this.$bus.$emit('showLotteryDialog', { type: 'lotteryRule' })
    },
    // 显示抽奖记录弹窗
    async showLotteryRecord() {
      this.$bus.$emit('showLotteryDialog', { type: 'lotteryRecord' })
    },
    moveLoop() {
      this.prizeIndex == 7 ? this.prizeIndex = 0 : this.prizeIndex++
      this.selectIndex = this.arrNum[this.prizeIndex]
    },
    // 开始抽奖
    startMove(index) {
      if (index != 4) return
      if (!this.isBindAccount) {
        this.CHANGE_BIND_GAME(true)
        return
      }
      if (!this.lotteryTimes) {
        Dialog.alert({
          title: '温馨提示',
          message: '当前抽奖次数已用尽!',
        })
        return
      }
      if (this.lotteryClickFlag) return;
      this.lotteryClickFlag = true
      // 快速转动
      this.timerQuick = setInterval(() => {
        this.moveLoop()
      }, 200)
      setTimeout(() => {
        this.changeSpeed()
      }, 3500)
    },
    // 转动速度变化的时候请求获奖信息
    async changeSpeed() {
      try {
        const r = await getLotteryResultInfo({
          lucky_draw_id: this.activityId
        })
        this.lotteryResult = r.data;
      } catch (error) {
        this.lotteryClickFlag = false
        return
      } finally {
        clearInterval(this.timerQuick)
      }
      // 慢速转动
      this.timerSlow = setInterval(() => {
        this.moveLoop()
      }, 500)
      setTimeout(() => {
        this.lotteryList.map((item, index) => {
          if (item.id == this.lotteryResult.id && index == this.selectIndex) {
            clearInterval(this.timerSlow)
            setTimeout(() => {
              this.$bus.$emit('showLotteryDialog', { type: 'lotteryResult', lotteryInfo: this.lotteryResult })
              this.lotteryClickFlag = false
            }, 500);
          }
        })
      }, 4000)
    }
  }
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable.scss';
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: 480px;
  padding-top: 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('#{$cdn-url-hm}/sign_gift_act/gift_bg_new.png');
  background-repeat: no-repeat;
  background-size: 276px auto;
  background-position: center;
  .btn-wrapper {
    padding-left: 20px;
    padding-right: 20px;
    width: 276px;
    height: 35px;
    display: flex;
    justify-content: space-between;
    > button {
      @include clearBtnDefaultStyle;
      background-repeat: no-repeat;
      background-size: cover;
    }
    > button:first-child {
      width: 67px;
      height: 33px;
      background-image: url('#{$cdn-url-hm}/sign_gift_act/gift_button_01.png');
    }
    > button:nth-child(2) {
      width: 67px;
      height: 32px;
      background-image: url('#{$cdn-url-hm}/sign_gift_act/gift_button_03.png');
    }
    // > button:nth-child(3) {
    //   width: 67px;
    //   height: 32px;
    //   background-image: url('#{$cdn-url-hm}/sign_gift_act/gift_button_03.png');
    // }
  }
  .lottery-wrapper {
    margin-top: 18px;
    width: 240px;
    height: 220px;
    .lottery-list {
      padding-top: 11px;
      padding-bottom: 5px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      .lottery-item {
        margin-left: 8.5px;
        width: 69px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('#{$cdn-url-hm}/sign_gift_act/gift_bg_01.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        > img {
          width: 69px;
          height: auto;
        }
        > div {
          position: absolute;
          margin-top: 18px;
          color: #fff;
          font-size: 10px;
        }
      }
    }
  }
  .radio-wrapper {
    width: 250px;
    height: 34px;
    margin-top: 16px;
  }
}
</style>